export const notificationsZIndex = "z-index: 50;"

export const chartDropdownZIndex = 10
